import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

const api = axios.create({
  baseURL: getApiBaseUrl(),
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const headers = config.headers || {};
    const hasContentType = Object.keys(headers).some(
      (name) => name.toLowerCase() === 'content-type'
    );

    if (!hasContentType && !(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      // Only redirect to login if we're on an admin page
      if (window.location.pathname.startsWith('/system-management-portal')) {
        window.location.href = '/system-management-portal/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

